window.addEventListener('load', () => {

    const buttons = document.querySelectorAll(".scrolly-player-control");

    buttons.forEach((button) => {
        const iconUse = button.querySelector("svg use");
        const iconBaseUrl = button.getAttribute("data-icon-base-url");
        const video = document.getElementById(button.getAttribute("data-video-id"));

        button.addEventListener("click", () => {
            if (video.paused || video.ended) {
                video.play();
                iconUse.setAttribute("xlink:href", iconBaseUrl + "icon-remix-pause-fill");
                button.setAttribute("aria-label", "Pause");
            } else {
                video.pause();
                iconUse.setAttribute("xlink:href", iconBaseUrl + "icon-remix-play-fill");
                button.setAttribute("aria-label", "Play");
            }
            button.blur();
        });
    });
});
